module.exports = require('./helpers/bundle-url').getBundleURL('gnRNX') + "teams-lite@4x.d4c05aaf.png" + "?" + Date.now();